import Axois from '../utils/axios'
import EventEmitter from "../../utils/eventEmitter";
import { useOutletContext } from 'react-router-dom';



export const loadStockRequests = async () => {
  let response = await Axois.get('/stock-requests').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadStockRequest = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/stock-requests');
        const responseData = await requests.data;
        return { ...responseData, stockRequest: {}};
        // return { products:[], locations:[], operationTypes:[], transfer: {}}
      
      default:
        let response = await Axois.get('/stock-requests/'+action);
        const responseJson = await response.data;
        return responseJson;
    }
  }catch (err) {
    console.log(err);
  }
}

export const loadStockRequestTransfers = async (number) => {
  let response = await Axois.get('/transfers/document/stock-request/'+number).catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
  const responseData = await response.data;
  return responseData;
}

// export const loadStockRequestTransfer = async (action) => {
//   let response = await Axois.get('/transfers/document/stock-request/').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
//   const responseData = await response.data;
//   return responseData;
// }

const useStockRequestAPI = () => {
  const { success, error } = useOutletContext();

  const create = async (data) => {
    try {
      const response = await Axois.post('/stock-requests', data);
      const responseData = await response.data;
      if (responseData.status === 'error') return error(responseData.message);
      success(responseData.message);
      EventEmitter.dispatch('stock_request_response', responseData.number);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (number, data) => {
    try {
      const response = await Axois.put('/stock-requests/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('stock_request_response', responseData.number);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        error(err.response?.data?.message);
      }
      throw err;
    }
  }

  const sendTransferRequest = async (data) => {
    try {
      const response = await Axois.patch('/stock-requests/', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('stock_request_response', responseData.number);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        // error(err.response.data.message);
      }
      throw err;
    }
  }

  const removeRequestLine = async (id) => {
    try {
      const response = await Axois.delete('/stock-requests/'+id);
      const responseData = await response.data;
      success(responseData.message);
      // EventEmitter.dispatch('stock_request_response', responseData.number);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        // error(err.response.data.message);
      }
      throw err;
    }
  }

  const getStockRequestTransfer = async (number) => {
    try {
      const response = await Axois.get('/transfers/document/stock-request/'+number);
      const responseData = await response.data;
      // EventEmitter.dispatch('stock_request_response', responseData.number);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        error(err.response?.data?.message);
      }
      throw err;
    }
  }

  return { create, update, sendTransferRequest, removeRequestLine, getStockRequestTransfer };
}


export default useStockRequestAPI;